// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

const BROWSER_AUDIO_REQUIRED_DESCRIPTOR = msg({
	message: 'Voice audio needs to be resumed',
	comment: 'Title of the modal shown when voice playback is suspended until the user interacts.',
});
const YOUR_BROWSER_REQUIRES_USER_INTERACTION_BEFORE_AUDIO_CAN_DESCRIPTOR = msg({
	message: 'Your voice connection is still active, but local audio playback is paused. Resume audio to hear the channel again.',
	comment: 'Body of the voice playback recovery modal explaining that a user gesture can resume local audio.',
});
const ENABLE_AUDIO_DESCRIPTOR = msg({
	message: 'Resume audio',
	comment: 'Primary button on the voice playback recovery modal. Resumes local audio playback.',
});

interface AudioPlaybackPermissionModalProps {
	onStartAudio: () => Promise<void>;
}

export const AudioPlaybackPermissionModal = observer(({onStartAudio}: AudioPlaybackPermissionModalProps) => {
	const {i18n} = useLingui();
	return (
		<ConfirmModal
			title={i18n._(BROWSER_AUDIO_REQUIRED_DESCRIPTOR)}
			description={i18n._(YOUR_BROWSER_REQUIRES_USER_INTERACTION_BEFORE_AUDIO_CAN_DESCRIPTOR)}
			primaryText={i18n._(ENABLE_AUDIO_DESCRIPTOR)}
			primaryVariant="primary"
			secondaryText={false}
			onPrimary={onStartAudio}
			data-flx="voice.audio-playback-permission-modal.confirm-modal"
		/>
	);
});
